import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import AssetImage from "src/components/wizard/Item/AssetImage";
import ItemCountBadge from "src/views/inventory/requests/ItemCountBadge";

const styles = {
  itemContainer: {
    cursor: "pointer",
    "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
  },
  description: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  locationText: {
    fontSize: 14,
    color: "text.secondary",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const getLocationInfo = rackLocations => {
  if (!rackLocations || rackLocations.length === 0) {
    return { mobileLocation: null, rackLocation: null, warehouseName: null };
  }

  const firstLocation = rackLocations[0];
  return {
    mobileLocation: firstLocation.mobile_warehouse_location?.location_name,
    rackLocation: firstLocation.warehouse_locations?.[0]?.location_name || null,
    warehouseName: firstLocation.warehouse?.name || null,
  };
};

export default function SelectItemToMove({ assets, onSelect, onClose }) {
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          gap={1}
          position="relative"
          width="100%"
        >
          <Typography color="textPrimary" fontSize={22} fontWeight={500}>
            Select Item to Move
          </Typography>
          <ItemCountBadge count={assets?.length || 0} />
          <IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 0, top: 0 }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          {assets?.map((asset, index) => {
            const { mobileLocation, rackLocation, warehouseName } = getLocationInfo(
              asset.rackLocations
            );

            return (
              <React.Fragment key={index}>
                {index > 0 && <Divider my={2} />}
                <Box
                  display="flex"
                  p={1}
                  gap={2}
                  sx={styles.itemContainer}
                  onClick={() => onSelect(asset)}
                >
                  <AssetImage width={100} height={90} image={asset?.images[0]?.url} />
                  <Box
                    flex={1}
                    display="flex"
                    flexDirection={{ xs: "column", sm: "row" }}
                    gap={{ xs: 1, sm: 2 }}
                  >
                    <Box flex={1}>
                      <Typography variant="body1" fontWeight={500} gutterBottom>
                        {asset.itemId}
                      </Typography>
                      <Typography variant="body1" gutterBottom sx={styles.description}>
                        {asset.description}
                      </Typography>
                      <Typography variant="body1">Quantity: {asset.availableQuantity}</Typography>
                    </Box>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems={{ xs: "flex-start", sm: "center" }}
                      minWidth={{ xs: "auto", sm: 150 }}
                    >
                      {mobileLocation && rackLocation ? (
                        <>
                          <Typography sx={styles.locationText} title={mobileLocation}>
                            {mobileLocation}
                          </Typography>
                          <Typography sx={styles.locationText}>-</Typography>
                          <Typography sx={styles.locationText} title={rackLocation}>
                            {rackLocation}
                          </Typography>
                        </>
                      ) : mobileLocation ? (
                        <Typography sx={styles.locationText} title={mobileLocation}>
                          {mobileLocation}
                        </Typography>
                      ) : rackLocation ? (
                        <Typography sx={styles.locationText} title={rackLocation}>
                          {rackLocation}
                        </Typography>
                      ) : (
                        <Typography sx={styles.locationText}>No location data</Typography>
                      )}
                      {warehouseName && (
                        <Typography sx={styles.locationText} title={warehouseName}>
                          {warehouseName}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </React.Fragment>
            );
          })}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
